import React, {ReactNode} from "react";
import {Navigate} from "react-router-dom";
import Loading from "@/components/loading";
import {observer} from "mobx-react-lite";
import {IRole} from "@/types/auth-data";
import {apiConfig} from "@/store";

interface ProtectRouteProps {
    roles:IRole[]
    children: ReactNode;
}

const ProtectRouteComponent: React.FC<ProtectRouteProps> = (props: ProtectRouteProps) => {
    const {roles, children} = props;
    const session = apiConfig.session
    const {role} = session;
    const {state} = apiConfig.endpoints.startSession
    if (state === "loading") {
        return <Loading/>
    }
    if (!!role && roles.indexOf(role) !== -1){
        return <>{children}</>
    } else {
        console.log(role, "protect");
        return <Navigate to="/login" replace/>;
    }
}

const ProtectRoute = observer(ProtectRouteComponent)
export default ProtectRoute;